module.exports = __webpack_public_path__ + "partner-ic.svg?2c47244228e885b610a280c8843b5d5f";